import { Badge } from "@/components/ui/badge";
import { ConvertStatusById } from "@/utils/convert-status-to-name/convert-status-to-name";
import { StatusBadgeProps } from "./status-badge.types";

export const StatusBadge = ({ status, type }: StatusBadgeProps) => {
  const CURRENT_STATUS_BADGE = ConvertStatusById({ status, type });

  return (
    <Badge variant={CURRENT_STATUS_BADGE?.badge_color}>
      {CURRENT_STATUS_BADGE?.title}
    </Badge>
  );
};
